import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink } from 'react-router-dom';

export default function PageUnauthorized() {
    return (
        <React.Fragment>
            <Box
                component="main"
                sx={{
                    backgroundColor: (theme) =>
                        theme.palette.mode === 'light'
                            ? theme.palette.grey[100]
                            : theme.palette.grey[900],
                    alignItems: 'center',
                    display: 'flex',
                    flexGrow: 1,
                    minHeight: '100vh'
                }}
            >
                <Container maxWidth={'sm'}>
                    <Typography variant="h1" paragraph>
                        401
                    </Typography>

                    <Typography variant="h3" paragraph>
                        Desculpe, mas essa página exige autorização!
                    </Typography>

                    <Typography sx={{ color: 'text.secondary' }} paragraph>
                        Para ter acesso a essa área é necessário se autenticar. Utilize a página de login para realizar a autenticação.
                    </Typography>
                    <Button to="/" size="large" variant="contained" component={RouterLink}>
                        retornar para o login
                    </Button>
                </Container>
            </Box>
        </React.Fragment>

    )
}